export default theme => {
    return {}
}



// WEBPACK FOOTER //
// ./src/app/configuration/ComcastSMBPremarket/theme/components/scorecard/MetricsLabels/index.js